jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   // $( document ).on( "variant:changed", function( evt ) {
	   //   // console.log( evt.currentVariant );
	   //   // $('[data-variant-toggle]').hide(0);
	   //   // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   // });


// hide FBT list when current option is dupatta or pants 
  
$( document ).on( "variant:changed", function( evt ) {
  // console.log(evt)
    const fbtTitle = evt.target.querySelector('.sr4-fbt__title');
    const fbtList = evt.target.querySelector('.sr4-fbt__swatches');
    const fbtInput = evt.target.querySelectorAll('.sr4-fbt__swatches #addon_list_input')
    const fbtInputQty = evt.target.querySelectorAll('.sr4-fbt__swatches #addon_list_input_qty')
  if(evt.currentVariant.title.toLowerCase().includes('dupatta')
     || evt.currentVariant.title.toLowerCase().includes('pants') 
     || evt.currentVariant.title.toLowerCase().includes('lehnga')
     || evt.currentVariant.title.toLowerCase().includes('culottes')
     || evt.currentVariant.title.toLowerCase().includes('shawl')
     || evt.currentVariant.title.toLowerCase().includes('palazzo')
     || evt.currentVariant.title.toLowerCase().includes('saree')
     || evt.currentVariant.title.toLowerCase().includes('izzar')
     || evt.currentVariant.title.toLowerCase().includes('gharara')) {
      if (fbtTitle && fbtList) {
        fbtTitle.style.display = 'none';
        fbtList.style.display = 'none';
        fbtInput.forEach((ele)=>{
          ele.disabled = true;
        })
        fbtInputQty.forEach((ele)=>{
          ele.disabled = true;
        })
      }
  } else{
      if (fbtTitle && fbtList) {
        fbtTitle.style.display = 'block';
        fbtList.style.display = 'block';
        fbtInput.forEach((ele)=>{
          ele.disabled = false;
        })
        fbtInputQty.forEach((ele)=>{
          ele.disabled = false;
        })
      }
  }

  const productPrice = evt.target.querySelector('.sr4-product-price');
  const productAtc = evt.target.querySelector('.disable_form_class');
  const productFBT = evt.target.querySelector('.sr4-fbt__wrap');
  if (evt.currentVariant.title.toLowerCase().includes('heirloom shawl')) {
      productPrice.innerHTML = `<a href="https://api.whatsapp.com/send?phone=923000255595&amp;text=Interested in ${productPrice.dataset.producturl}" target="_blank" aria-describedby="a11y-new-window-external-message" rel="noopener">Inquire on whatsapp</a>`
      if (!productFBT) {
          if (productAtc) {
              productAtc.setAttribute('style', 'display: none !important');
          }
      } else {
          productFBT.setAttribute('style', 'display: none !important');
      }

  } else {
      if (!productFBT) {
          if (productAtc) {
              productAtc.setAttribute('style', 'display: block !important');
          } 
      } else {
          productFBT.setAttribute('style', 'display: block !important');
      }
  }
  const fbtPPS = evt.target.querySelector(`#parentProduct select option[data-variantcon="${evt.currentVariant.title}"]`);
    if (fbtPPS) {
      fbtPPS.selected = true;
    }  
})
  
// $( document ).on( "variant:changed", function( evt ) {
//   console.log(evt.currentVariant.id)
//   document.querySelector(`.main_product_hiddens select[data-groups-pr-sl] option[value="${evt.currentVariant.id}"]`).selected = true;
// });
  
});